import { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

function fmtDate(d) {
  const months = ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Ags", "Sep", "Okt", "Nov", "Des"];
  const p = (n) => String(n).padStart(2, "0");
  return `${p(d.getDate())}-${months[d.getMonth()]}-${d.getFullYear()} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`;
}

export default function TopBar() {
  const { user, sites, activeSite, setActiveSite } = useAuth();
  const [now, setNow] = useState(new Date());
  const [counters, setCounters] = useState({ memo: 0, deposit: 0, withdraw: 0 });

  const loadCounters = useCallback(() => {
    if (user?.role === "staff") api.get("/counters").then((r) => setCounters(r.data)).catch(() => {});
  }, [user]);

  useEffect(() => { const t = setInterval(() => setNow(new Date()), 1000); return () => clearInterval(t); }, []);
  useEffect(() => { loadCounters(); const t = setInterval(loadCounters, 4000); return () => clearInterval(t); }, [loadCounters]);

  const showSelector = user && (user.role === "super_admin" || (user.role === "trainer" && sites.length > 1));

  return (
    <div className="topstrip" data-testid="header-bar">
      <span className="date" data-testid="current-datetime">{fmtDate(now)}</span>
      <span className="counters">
        <span data-testid="counter-memo">Memo({counters.memo})</span>,{" "}
        <span data-testid="counter-deposit">Deposit({counters.deposit})</span>,{" "}
        <span data-testid="counter-withdraw">Withdraw({counters.withdraw})</span>
      </span>
      <div className="right">
        {showSelector && (
          <span data-testid="website-selector-wrap" style={{ fontSize: 11 }}>
            Current Website:{" "}
            <select value={activeSite || ""} onChange={(e) => setActiveSite(e.target.value)} data-testid="website-selector"
              style={{ fontSize: 11, border: "1px solid #b9cbdd", padding: "2px 4px" }}>
              {sites.map((s) => <option key={s.site_id} value={s.site_id}>{s.display_name} ({s.site_id})</option>)}
            </select>
          </span>
        )}
        <button className="btn-refresh" onClick={loadCounters} data-testid="refresh-btn">Refresh</button>
        <span className="training-badge" data-testid="training-mode-badge">TRAINING MODE</span>
      </div>
    </div>
  );
}
